module.exports = __webpack_public_path__ + "img/img_0@2x.2f7bf151.png";